module.exports = __webpack_public_path__ + "assets/img/Arty_Paris_002.820b81de-ps.jpg";